import {combineReducers} from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import valuePackSlice from "./slices/valuePackSlice";
import industryReducer from "./slices/industrySlice";

import faqReducer from './slices/faqSlice';
import testimonialReducer from './slices/testimonialSlice';
import categoriesReducer from './slices/categoriesSlice';
import servicePlanReducer from './slices/servicePlanSlice';



const rootReducer = combineReducers({
  auth: authSlice,
  valuePack: valuePackSlice,
  industries: industryReducer,
  faq: faqReducer,
  testimonial: testimonialReducer,
  categories: categoriesReducer,
  servicePlan: servicePlanReducer, 
});

export default rootReducer;


// import { combineReducers } from '@reduxjs/toolkit';
// import { persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';

// import authSlice from './slices/authSlice';
// import valuePackSlice from "./slices/valuePackSlice";

// // Persist config only for auth
// const authPersistConfig = {
//   key: 'auth',
//   storage,
// };

// const rootReducer = combineReducers({
//   auth: persistReducer(authPersistConfig, authSlice), // only auth is persisted
//   valuePack: valuePackSlice, // not persisted
// });

// export default rootReducer;
